module.exports = __webpack_public_path__ + "static/media/4.1bcd2514.jpg";